export const ns = "FreeCommSpace"

export default {
  [ns]: {
    freeCommSpace: "Communication libre",
    fav: "Favoris",
  },
}
